import { render } from "./OurStoryView.vue?vue&type=template&id=d32d79ac&scoped=true"
import script from "./OurStoryView.vue?vue&type=script&lang=js"
export * from "./OurStoryView.vue?vue&type=script&lang=js"

import "./OurStoryView.vue?vue&type=style&index=0&id=d32d79ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32d79ac"]])

export default __exports__